<template>
  <div>
    <div style="border-bottom: #666666 2px solid">
      <div class="dialog-title">
        <span class="order-no">特患申请编号：TSFY20210301001</span>
        <div class="status">
          <img src="/static/status-icon.png" alt="">
          <span>已提交</span>
        </div>
      </div>
      <div class="screen">
        <div class="form">
          <div class="form-line">
            <div class="form-item">
              <span class="label">患儿姓名</span>
              <input type="text" disabled v-model="info.data1">
            </div>
            <div class="form-item">
              <span class="label">性别</span>
              <input type="text" v-model="info.data2">
            </div>
            <div class="form-item">
              <span class="label">出生日期</span>
              <input type="text" disabled v-model="info.data3">
            </div>
            <div class="form-item">
              <span class="label">身份证号</span>
              <input type="text" disabled v-model="info.data3">
            </div>
          </div>
          <div class="form-line">
            <div class="form-item">
              <span class="label">户口所在地</span>
              <input type="text" disabled v-model="info.data1">
            </div>
            <div class="form-item">
              <span class="label">救助医院</span>
              <input type="text" disabled v-model="info.data2">
            </div>
            <div class="form-item">
              <span class="label">病 种</span>
              <input type="text" disabled v-model="info.data1">
            </div>
          </div>
          <div class="form-line">

            <div class="form-item">
              <span class="label">申请类型</span>
              <div class="radio-view">
                <el-radio v-model="info.data3" label="1">是</el-radio>
                <el-radio v-model="info.data3" label="2">否</el-radio>
              </div>
            </div>
            <div class="form-item">
              <span class="label">申请金额</span>
              <input type="text" disabled v-model="info.data1">
            </div>
            <div class="form-item">
              <span class="label">特殊类型</span>
              <div class="radio-view">
                <el-radio v-model="info.data3" label="1">是</el-radio>
                <el-radio v-model="info.data3" label="2">否</el-radio>
              </div>
            </div>
          </div>
          <div class="form-line">
            <div class="form-item">
              <span class="label">申请理由</span>
              <textarea rows="3" cols="20" disabled style="width: 27.083vw" v-model="info.data1">
          </textarea>
            </div>
          </div>
          <div class="form-line">
            <div class="form-item">
              <span class="label">申请备注</span>
              <textarea rows="3" cols="20" disabled style="width: 27.083vw" v-model="info.data1">
          </textarea>
            </div>
          </div>
          <div class="form-line" style="height: 6vw">
            <div class="form-item">
              <span class="label">附 件</span>
              <span class="link">特患申请提升治疗费用附加.rar</span>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-title">
        <span class="order-no">辅助信息</span>
      </div>
      <div class="screen" style="margin-bottom: 2.083vw">
        <div class="form">
          <div class="form-line">
            <div class="form-item">
              <span class="label">申请时间</span>
              <input type="text" disabled v-model="info.data1">
            </div>
            <div class="form-item">
              <span class="label">审核时间</span>
              <input type="text" disabled v-model="info.data2">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="border-bottom: #666666 2px solid">
      <div class="dialog-title">
        <span class="order-no">特患申请编号：TSFY20210301001</span>
        <div class="status">
          <img src="/static/status-icon.png" alt="">
          <span>已提交</span>
        </div>
      </div>
      <div class="screen">
        <div class="form">
          <div class="form-line">
            <div class="form-item">
              <span class="label">患儿姓名</span>
              <input type="text" disabled v-model="info.data1">
            </div>
            <div class="form-item">
              <span class="label">性别</span>
              <input type="text" v-model="info.data2">
            </div>
            <div class="form-item">
              <span class="label">出生日期</span>
              <input type="text" disabled v-model="info.data3">
            </div>
            <div class="form-item">
              <span class="label">身份证号</span>
              <input type="text" disabled v-model="info.data3">
            </div>
          </div>
          <div class="form-line">
            <div class="form-item">
              <span class="label">户口所在地</span>
              <input type="text" disabled v-model="info.data1">
            </div>
            <div class="form-item">
              <span class="label">救助医院</span>
              <input type="text" disabled v-model="info.data2">
            </div>
            <div class="form-item">
              <span class="label">病 种</span>
              <input type="text" disabled v-model="info.data1">
            </div>
          </div>
          <div class="form-line">

            <div class="form-item">
              <span class="label">申请类型</span>
              <div class="radio-view">
                <el-radio v-model="info.data3" label="1">是</el-radio>
                <el-radio v-model="info.data3" label="2">否</el-radio>
              </div>
            </div>
            <div class="form-item">
              <span class="label">申请金额</span>
              <input type="text" disabled v-model="info.data1">
            </div>
            <div class="form-item">
              <span class="label">特殊类型</span>
              <div class="radio-view">
                <el-radio v-model="info.data3" label="1">是</el-radio>
                <el-radio v-model="info.data3" label="2">否</el-radio>
              </div>
            </div>
          </div>
          <div class="form-line">
            <div class="form-item">
              <span class="label">申请理由</span>
              <textarea rows="3" cols="20" disabled style="width: 27.083vw" v-model="info.data1">
          </textarea>
            </div>
          </div>
          <div class="form-line">
            <div class="form-item">
              <span class="label">申请备注</span>
              <textarea rows="3" cols="20" disabled style="width: 27.083vw" v-model="info.data1">
          </textarea>
            </div>
          </div>
          <div class="form-line" style="height: 6vw">
            <div class="form-item">
              <span class="label">附 件</span>
              <span class="link">特患申请提升治疗费用附加.rar</span>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-title">
        <span class="order-no">辅助信息</span>
      </div>
      <div class="screen" style="margin-bottom: 2.083vw">
        <div class="form">
          <div class="form-line">
            <div class="form-item">
              <span class="label">申请时间</span>
              <input type="text" disabled v-model="info.data1">
            </div>
            <div class="form-item">
              <span class="label">审核时间</span>
              <input type="text" disabled v-model="info.data2">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    downLoadFileApi, //下载图片
    getFamilyAttachInfo, //按救助编号查询保险列表
    getFamilyDataByHelpId, // 按救助编号查询患儿家庭情况
    getGuardianAttachInfo, // 获取监护人附件信息
    getInsureDataByHelpId, // 按救助编号查询保险列表
    getJzshDataListByCondNoPaging, //获取患儿审核记录，不分页
    getParentsDataByHelpId, //按救助编号查询监护人列表
    getRequestAttachInfo, // 获取患儿附件信息
  } from "../../../util/api";
  export default {
    props: {
      dialogDetail: false,
      helpId: '',
      resData: {
        type: Object,
        value: () => {}
      },
      applyData: {
        type: Object,
        value: () => {}
      },
    },
    data() {
      return {
        innerVisible: false,
        isShow: this.dialogDetail,
        dialogName: 'first',
        ill: '',
        dialogImageUrl: '',
        dialogImageVisible: false,
        disabled: false,
        parentsList: [],
        jzshList: [],
        infoList: [],
        files: {
          dbzmFIle: '',
          fpzmFile: '',
          onlyOneFile: '',
          zdzmImage: [],
          consentList: [],
          poorEvidenceList: [],
          lifePhotoList: [],
          inHospitalPhotoList: [],
          familyPhotoList: [],
          poorNarrateList: [],
          registerPageList: [],
          gruandRegisterPageList: [],
          otherMaterialList: [],
          idCardList: [],
          facePhotoList: [],
          birthCertificateList: [],

          proofFile: [],
          reportFile: [],
          diseaseInfoFile: [],
          rescueFile: [],
          BultrasonicFile: [],
          postoperationFile: []
        },
        info:{}
      }
    },
    created() {
      this.queryFamily(this.helpId)
      this.getInsure(this.helpId)
      this.getFamilyAttach(this.helpId)
      this.getJzshDataList()
      this.getRequestAttachInfo()
      this.getRequestAttach()
      this.getParentsData()
      if (this.resData.requestTime) {
        this.resData.requestTime = this.makeDate(parseInt(this.resData.requestTime))
      }
      if (this.resData.registerTime) {
        this.resData.registerTime = this.makeDate(parseInt(this.resData.registerTime))
      }
      this.resData.diseasesList.forEach((item, index) => {
        if (index == 0) {
          this.ill = item.diseasesName
        } else {
          this.ill = this.ill + '/' + item.diseasesName
        }
      })
    },
    methods: {
      //获取监护人信息
      getParentsData() {
        this.files.gruandRegisterPageList = []
        this.files.idCardList = []
        getParentsDataByHelpId({
          helpId: this.helpId
        }).then(res => {
          this.parentsList = res.responseData
          if (res.responseData.length) {
            res.responseData.forEach((item, index) => {
              //监护人户口本
              getGuardianAttachInfo({
                "subDataId": item.guardianId,
                "attachType": "21"
              }).then(res1 => {
                if (res1.responseData > 0) {
                  let _param = {
                    list: [res1.responseData[0].attachId]
                  }
                  downLoadFileApi(_param).then(res2 => {
                    this.files.gruandRegisterPageList.concat(res2.responseData)
                  })
                }

              })
              //监护人身份证
              getGuardianAttachInfo({
                "subDataId": item.guardianId,
                "attachType": "22"
              }).then(res1 => {
                if (res1.responseData > 0) {
                  let _param = {
                    list: [res1.responseData[0].attachId]
                  }
                  downLoadFileApi(_param).then(res2 => {
                    this.files.idCardList.concat(res2.responseData)
                  })
                }
              })
            })
          }
        })
      },
      //获取附件
      getRequestAttach() {
        //知情同意书
        getRequestAttachInfo({
          "helpReqId": this.resData.helpReqId,
          "attachType": "1"
        }).then(res => {
          if (res.responseData > 0) {
            let _param = {
              list: [res.responseData[0].attachId]
            }
            downLoadFileApi(_param).then(res1 => {
              this.files.consentList = res1.responseData
            })
          }
        })
        //贫困证明
        getRequestAttachInfo({
          "helpReqId": this.resData.helpReqId,
          "attachType": "2"
        }).then(res => {
          if (res.responseData > 0) {
            let _param = {
              list: [res.responseData[0].attachId]
            }
            downLoadFileApi(_param).then(res1 => {
              this.files.poorEvidenceList = res1.responseData
            })
          }
        })
        //患儿生活照
        getRequestAttachInfo({
          "helpReqId": this.resData.helpReqId,
          "attachType": "4"
        }).then(res => {
          if (res.responseData > 0) {
            let _param = {
              list: [res.responseData[0].attachId]
            }
            downLoadFileApi(_param).then(res1 => {
              this.files.lifePhotoList = res1.responseData
            })
          }
        })
        //患儿在院照片
        getRequestAttachInfo({
          "helpReqId": this.resData.helpReqId,
          "attachType": "5"
        }).then(res => {
          if (res.responseData > 0) {
            let _param = {
              list: [res.responseData[0].attachId]
            }
            downLoadFileApi(_param).then(res1 => {
              this.files.inHospitalPhotoList = res1.responseData
            })
          }

        })
        //患儿家人全家福
        getRequestAttachInfo({
          "helpReqId": this.resData.helpReqId,
          "attachType": "6"
        }).then(res => {
          if (res.responseData > 0) {
            let _param = {
              list: [res.responseData[0].attachId]
            }
            downLoadFileApi(_param).then(res1 => {
              this.files.familyPhotoList = res1.responseData
            })
          }
        })
        //家庭困难自述
        getRequestAttachInfo({
          "helpReqId": this.resData.helpReqId,
          "attachType": "7"
        }).then(res => {
          if (res.responseData > 0) {
            let _param = {
              list: [res.responseData[0].attachId]
            }
            downLoadFileApi(_param).then(res1 => {
              this.files.poorNarrateList = res1.responseData
            })
          }

        })
        //患儿所在户口本的户主页
        getRequestAttachInfo({
          "helpReqId": this.resData.helpReqId,
          "attachType": "8"
        }).then(res => {
          if (res.responseData > 0) {
            let _param = {
              list: [res.responseData[0].attachId]
            }
            downLoadFileApi(_param).then(res1 => {
              this.files.registerPageList = res1.responseData
            })
          }

        })
        //其他资料
        getRequestAttachInfo({
          "helpReqId": this.resData.helpReqId,
          "attachType": "3"
        }).then(res => {
          if (res.responseData > 0) {
            let _param = {
              list: [res.responseData[0].attachId]
            }
            downLoadFileApi(_param).then(res1 => {
              this.files.otherMaterialList = res1.responseData
            })
          }

        })

        //患儿大头照
        getRequestAttachInfo({
          "helpReqId": this.resData.helpReqId,
          "attachType": "9"
        }).then(res => {
          if (res.responseData > 0) {
            let _param = {
              list: [res.responseData[0].attachId]
            }
            downLoadFileApi(_param).then(res1 => {
              this.files.facePhotoList = res1.responseData
            })
          }

        })

        //患儿出生证明
        getRequestAttachInfo({
          "helpReqId": this.resData.helpReqId,
          "attachType": "10"
        }).then(res => {
          if (res.responseData > 0) {
            let _param = {
              list: [res.responseData[0].attachId]
            }
            downLoadFileApi(_param).then(res1 => {
              this.files.birthCertificateList = res1.responseData
            })
          }

        })

      },


      makeDate(time) {
        let _date = new Date(time)
        var y = _date.getFullYear();
        var m = _date.getMonth() + 1;
        var d = _date.getDate();
        return y + '-' + m + '-' + d;
      },
      getInsure(id) {
        getInsureDataByHelpId({
          helpId: id
        }).then(res => {})
      },
      getFamilyAttach(id) {
        getFamilyAttachInfo({
          helpId: id,
          attachType: '11'
        }).then(res => {
          this.files.dbzmFIle = res.responseData
        })
        getFamilyAttachInfo({
          helpId: id,
          attachType: '12'
        }).then(res => {
          this.files.fpzmFile = res.responseData
        })
        getFamilyAttachInfo({
          helpId: id,
          attachType: '13'
        }).then(res => {
          this.files.onlyOneFile = res.responseData
        })
      },
      //获取患儿附件
      getRequestAttachInfo() {
        getRequestAttachInfo({
          helpReqId: this.resData.helpReqId,
          attachType: '21'
        }).then(res => {
          this.zdzmImage = res.responseData
        })
      },
      //救助申请审核记录
      getJzshDataList() {
        let params = {
          "searchCond": {
            "helpId": this.helpId,
          }
        }
        getJzshDataListByCondNoPaging(params).then(res => {
          this.jzshList = res.responseData.modelData
        })
      },
      closeDetail() {
        this.$emit("update:dialogDetail", false);
      },
      handleRemove(file) {},
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogImageVisible = true;
      },
      handleDownload(file) {
        console.log(file);
      },
      queryFamily(id) {
        getFamilyDataByHelpId({
          helpId: id
        }).then(res => {
          this.info = res.responseData
          this.infoList.push(this.info)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dialog-content {
    width: 100%;
    background-color: #ffffff;

    .btn-view {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .btn {
        width: 4.063vw;
        height: 1.875vw;
        background: #E8556F;
        border-radius: 0.208vw;
        display: flex;
        align-items: center;
        justify-content: center;

        margin-right: 1.563vw;

        img {
          width: 0.781vw;
          height: 0.781vw;
          margin-right: 0.26vw;
        }

        span {
          font-size: 12px;
          font-family: PingFangSC;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
    }

    .dialog-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: #bfbfbf 0.052vw solid;
      height: 3.125vw;

      .order-no {
        font-size: 16px;
      }

      .status {
        display: flex;
        align-items: center;

        img {
          width: 0.781vw;
          height: 0.781vw;
          margin-right: 0.521vw;
        }

        span {
          font-size: 12px;
        }
      }
    }

    .screen {
      width: 100%;
      height: auto;
      min-height: 30%;

      .form {
        width: 100%;
      }

      .value-box {
        width: 9.375vw;
        font-size: 12px;
        height: 1.6vw;
        background-color: #f8f8f8;
        border: #d0d0d0 1px solid;
        line-height: 1.6vw;
        padding: 2px;
        border-radius: 2px;
      }

      .fj {
        display: flex;
        margin-top: 1.042vw;
        flex-direction: column;

        .fj-title {
          display: flex;
          align-items: center;
          height: 1.042vw;

          .shu {
            width: 0.104vw;
            height: 0.521vw;
            background-color: #dc243e;
          }

          span {
            font-size: 12px;
            margin-left: 0.26vw;
          }
        }

        .fj-name {

          margin-top: 0.521vw;
          font-size: 12px;
        }

        img {
          width: 6.25vw;
          height: 6.25vw;
          background-color: #666666;
          margin-top: 0.26vw;
        }
      }

      .form-line {
        display: flex;
        align-items: center;
        width: 100%;
        height: 3.125vw;

        .close-form {
          flex-shrink: 0;

          img {
            width: 0.625vw;
            height: 0.521vw;
          }

          span {
            font-size: 12px;
            font-family: PingFangSC;
            font-weight: bold;
            color: #999999;
          }
        }

        .photo {
          width: 8vw;
          height: 5vw;
          margin-right: 1vw;
          background-color: #666666;
        }

        .form-item {
          display: flex;
          margin-right: 2vw;
          align-items: center;
          position: relative;
          flex-shrink: 1;

          .error {
            position: absolute;
            display: flex;
            font-size: 12px;
            color: #dc243e;
            bottom: -1.302vw;
            align-items: center;

            img {
              width: 0.729vw;
              height: 0.729vw;
              margin-right: 0.26vw;
            }

            span {
              font-size: 0.625vw;
            }
          }

          .label {
            display: block;
            width: 4.167vw;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          .value-box {
            width: 9.375vw;
            font-size: 12px;
            height: 1.6vw;
            background-color: #f8f8f8;
            border: #d0d0d0 1px solid;
            line-height: 1.6vw;
            padding: 2px;
            border-radius: 2px;
          }

          input {
            width: 9.375vw;
            font-size: 12px;
            height: 1.6vw;
            //border: none;
            //border-bottom: #B3B3B3 0.052vw solid;
            outline: none;
          }

          select {
            width: 9.375vw;
            font-size: 0.729vw;
            border: none;
            border-bottom: #B3B3B3 0.052vw solid;
            outline: none;
          }

          textarea {
            resize: none;
            outline: none;
            font-size: 12px;
          }

          /deep/ .el-upload--picture-card {
            width: 5.208vw;
            height: 5.208vw;
            line-height: 5.729vw
          }

          /deep/ .el-radio__label {
            font-size: 12px !important;
          }

          .radio-view {
            width: 9.375vw;
            margin-left: 0.5vw;
          }

          /deep/ .el-date-editor.el-input,
          .el-date-editor.el-input__inner {
            width: 5.208vw;

            input {
              font-size: 12px;
              height: 1.042vw;
              text-align: center;
              border: none;
              border-bottom: #B3B3B3 0.052vw solid;
              outline: none;
              padding: 0;
              border-radius: 0;
            }
          }

          /deep/ .el-input__prefix {
            display: none !important;
          }

          /deep/ .el-input__suffix {
            display: none !important;
          }
        }

        .btn {
          width: 4.063vw;
          height: 1.875vw;
          background: #E8556F;
          border-radius: 0.208vw;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin-right: 1.563vw;

          img {
            width: 0.781vw;
            height: 0.781vw;
            margin-right: 0.26vw;
          }

          span {
            font-size: 12px;
            font-family: PingFangSC;
            font-weight: bold;
            color: #FFFFFF;
          }
        }

        .new {
          margin-left: 20vw;
          margin-right: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/child/audit/specialChild.vue